import React from 'react'
import ReceivedSvg from "../../assets/icons/Received.svg"

const Received = () => {
  return (
    <img src={ReceivedSvg} alt='Received'/>
  )
}

export default Received;